import { z } from "zod";

export const DTODocumentationPublishMetadata = z.object({
  lastPublishedByUserId: z.string(),
  lastPublishedAt: z.coerce.date(),
});

export type DTODocumentationPublishMetadata = z.infer<typeof DTODocumentationPublishMetadata>;
